<template>
  <div id="scheduleDetail_dataAnalysis">
    <MoreThemeList
      v-if="findAnalysisItemParams"
      :axiosBaseUrl="axiosBaseUrl"
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :findAnalysisItemParams="findAnalysisItemParams"
      :paramsChangeObj="paramsChangeObj"
      :curTimeZoneItem="curTimeZoneItem"
    ></MoreThemeList>
  </div>
</template>

<script>
import MoreThemeList from '@components/base/theme/more_themeList.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'scheduleDetail_dataAnalysis',
  mixins: [cup_base_data_mixin],
  components: {
    MoreThemeList,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      themeTemplateType: 40,
      findAnalysisItemParams: null,
      paramsChangeObj: {
        type: '',
        num: 0,
      },
    }
  },
  created() {
    if (this.currSportsDetail && this.currSportsDetail.matchId) {
      this.init()
    } else {
    }
  },
  mounted() {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.renderThemeList = null
      console.debug('scheduleDetail_dataAnalysis')
      this.makeAnalysisItemParams(this.themeTemplateType)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'tennis',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: this.currSportsDetail.eventId,
        pid: 0,
        mid: this.currSportsDetail.matchId,
      }
      let { num } = this.paramsChangeObj
      this.paramsChangeObj = {
        type: 'reset',
        num: num + 1,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#scheduleDetail_dataAnalysis {
  width: 100%;
  height: auto;
}

</style>
